let barcode = "";
let reading = false;
let scanner = true;

export function startBarcodeScanner(vm) {
    window.addEventListener("focusout", () => {
        scanner = true;
    });

    window.addEventListener("focusin", () => {
        scanner = false;
    });



    window.addEventListener("keydown", (e) => {
        const keyboard = e.key;
        if (vm.$vuetify.breakpoint.xs) {
            scanner = true;
        }
        if (scanner) {
            console.log(keyboard);
            if (keyboard === "Enter") {
                e.preventDefault();
                vm.searchProduct(barcode);
                barcode = "";
            } else if (keyboard.length === 1) {
                // Aceita qualquer sscaractere de um único dígito/letra/símbolo
                barcode += keyboard;
            } else {
                return;
            }

            if (!reading) {
                reading = true;
                setTimeout(() => {
                    barcode = "";
                    reading = false;
                }, 400);
            }
        }
    });
}